import { useFirebase, useFirebaseConnect } from 'react-redux-firebase'
import { RootState } from '../../../store'
import {
  CANCEL_LIST,
  INDIVIDUAL_UNITS,
  UNITS_MASTER,
} from '../../../firebase/config'
import { useDispatch, useSelector } from 'react-redux'
import { usePreviousDifferent } from 'rooks'
import React from 'react'
import {
  actions as unitActions,
  UnitMaster,
  UnitCancel,
} from '../../Units/reducer'
import isEqual from 'lodash/isEqual'

/** Firebase ordered list item shape (key + value). */
type FirebaseOrderedItem<T> = { key: string; value: T }

function extractValues<T>(
  ordered: FirebaseOrderedItem<T>[] | undefined
): T[] {
  if (!ordered || !Array.isArray(ordered)) return []
  return ordered.map((item) => {
    if (
      item.value != null &&
      typeof item.value === 'object' &&
      !Array.isArray(item.value)
    ) {
      const value = item.value as { id?: string }
      return {
        ...value,
        id: value.id ?? item.key,
      } as T
    }

    return item.value
  })
}

export const useSetUnits = () => {
  const dispatch = useDispatch()
  const firebase = useFirebase()

  const unitsMaster = useSelector(
    (state: RootState) => state.firebase.ordered?.unitsmaster
  )
  const unitsIndividual = useSelector(
    (state: RootState) => state.firebase.ordered?.individualunits
  )
  const unitsCancel = useSelector(
    (state: RootState) => state.firebase.ordered?.cancellist
  )

  const unitsMasterPrev = usePreviousDifferent(unitsMaster)
  const unitsIndividualPrev = usePreviousDifferent(unitsIndividual)
  const unitsCancelPrev = usePreviousDifferent(unitsCancel)

  useFirebaseConnect(() => [
    { path: UNITS_MASTER },
    { path: INDIVIDUAL_UNITS },
    { path: CANCEL_LIST },
  ])

  React.useEffect(() => {
    if (!firebase) return
    firebase.watchEvent('value', UNITS_MASTER, '')
    firebase.watchEvent('value', INDIVIDUAL_UNITS, '')
    firebase.watchEvent('value', CANCEL_LIST, '')
  }, [firebase])

  React.useEffect(() => {
    if (!isEqual(unitsMaster, unitsMasterPrev) && unitsMaster) {
      const values = extractValues<UnitMaster>(
        unitsMaster as FirebaseOrderedItem<UnitMaster>[]
      )
      dispatch(unitActions.onUnitsMaster(values))
    }
  }, [unitsMaster, unitsMasterPrev, dispatch])

  React.useEffect(() => {
    if (!isEqual(unitsIndividual, unitsIndividualPrev) && unitsIndividual) {
      const values = extractValues<UnitMaster>(
        unitsIndividual as FirebaseOrderedItem<UnitMaster>[]
      )
      dispatch(unitActions.onUnitsIndividual(values))
    }
  }, [unitsIndividual, unitsIndividualPrev, dispatch])

  React.useEffect(() => {
    if (!isEqual(unitsCancel, unitsCancelPrev) && unitsCancel) {
      const values = extractValues<UnitCancel>(
        unitsCancel as FirebaseOrderedItem<UnitCancel>[]
      )
      dispatch(unitActions.onUnitsCancel(values))
    }
  }, [unitsCancel, unitsCancelPrev, dispatch])
}
